export default function renderAssigneeLabel({ login }) {
  return {
    content: login,
  }
}
